import { useState } from 'react';
import { WidgetSections, WidgetsTemplate } from '../types/pointsWidgetstypes';

export const usePointsSearch = (sectionsWidgets: WidgetSections) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<WidgetsTemplate[]>([]);

  const handleSearch = (term: string) => {
    const normalizedTerm = term.toLowerCase();
    setSearchTerm(term);
    if (term) {
      const results: WidgetsTemplate[] = Object.values(sectionsWidgets).reduce<WidgetsTemplate[]>(
        (acc, { widgets }) => {
          const matchingWidgets = widgets
            .map((widget) => ({
              ...widget,
              points: widget.points.filter((point) => {
                return (
                  widget.widgetLabel?.toLowerCase().includes(normalizedTerm) ||
                  point.entry.description.toLowerCase().includes(normalizedTerm) ||
                  point.entry.name.toLowerCase().includes(normalizedTerm)
                );
              }),
            }))
            .filter((widget) => widget.points.length > 0);

          return [...acc, ...matchingWidgets];
        },
        []
      );
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  const clearSearch = () => {
    setSearchResults([]);
    setSearchTerm('');
  };

  return {
    searchTerm,
    searchResults,
    handleSearch,
    clearSearch,
  };
};
